<template>
    <svg
    class="svgStop"
        @click="clicked"
            @mouseout="mouseover"
            @mouseleave="mouseleave"
            @mouseenter="mouseenter"
            @mousedown="mousedown"
             width="18" height="18" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
    >  
    <circle cx="45" cy="45" r="44.5" stroke="black"/>
    <rect x="27" y="27" width="36" height="36" rx="3" fill="black"/>
</svg>
</template>
<script>
export default {
    props:["color"],
    methods: {
        clicked() {
            this.$emit('clicked')
        },
        mouseover() {
            this.$emit('mouseover')
        },
        mouseleave() {
            this.$emit('mouseleave')
        },
        mousedown() {
            this.$emit('mousedown')
        },
        mouseenter() {
            this.$emit('mouseenter')
        },
    }
}
</script>
<style>
.svgStop:hover path {
    stroke:#EF2035;
    fill:#EF2035;
    
    stroke-width:2;
}

.svgStop:hover circle {
    stroke:#EF2035;
    stroke-width:6;
    cursor:pointer;
}
.svgStop:hover rect {
    fill:#EF2035;
    stroke-width:6;
    cursor:pointer;
}
</style>